<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div *ngIf="loading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div class="p-3 h-100" style="background-color: white;">
    <div class="pt-3 px-2 bg-white d-flex flex-column h-100" style=" border:1px solid #3f3f3f53; border-radius: 20px;">
        <form [formGroup]="payInForm" class="mb-4">
            <div class="sub-head">Pay in details</div>
            <div class=" py-2 px-1">
                <label for="amount" class="label mb-0">Customer* </label>
                <ng-select formControlName="customer" [items]="usersList" bindLabel="FirstName"
                    [searchable]="true" [clearable]="false" class="w-100">
                    <ng-template ng-option-tmp let-user="item">
                        <div class="d-flex align-items-center">
                            <i *ngIf="user.UserType === 'user'" class="bi bi-person mr-2"></i>
                            <i *ngIf="user.UserType === 'shop'" class="material-icons mr-2"
                                style="font-size:17px;">storefront</i>
                            {{ user.FirstName }}
                        </div>
                    </ng-template>
                </ng-select>
                <div *ngIf="customer?.touched && customer?.invalid" class="text-danger small mt-1">
                    <div *ngIf="customer?.errors?.['required']">Customer is required.</div>
                </div>
            </div>

            <div class=" py-2 px-1">
                <label for="amount" class="label mb-0">Pay In Amount*</label>
                <input type="number" id="amount" class="form-control input-fields-q5" formControlName="amount" />
            </div>
            <div *ngIf="amount?.touched && amount?.invalid" class="text-danger small mt-1">
                <div *ngIf="amount?.errors?.['required']">Amount is required.</div>
                <div *ngIf="amount?.errors?.['min']">Amount must be at least 1.</div>
            </div>
            <div class="py-2 px-1">
                <label for="amount" class="label mb-0">Payment* </label>
                <button class="btn btn-primary form-control" [disabled]="payInForm.invalid"
                    style="background-color:#fff; color:#808080; border-color:#808080; border-radius: 10px;"
                    (click)="openPaymentModal()">Select</button>
            </div>
        </form>
    </div>
</div>

<app-payment-methods *ngIf="showPaymentModesModal" [totalReceivable]="payInForm.get('amount').value"
    [calledFrom]="calledFrom" (close)="handlePaymentModalClose()"
    (paymentSaved)="handlePaymentSaved($event)"></app-payment-methods>